import {Link} from "react-router-dom";
import {StyledNoUpcomingCallBox} from "../../../../components/calls/upcoming-calls/upcoming-calls.style";
import {Button} from "antd";

export function GetDiscountCodesEmptyState() {
  return (
    <StyledNoUpcomingCallBox>
      <p className="info-text">
        You do not have any discount code at the moment. Offer promotions to your
        customers by generating discount codes
      </p>
      <div>
        <Link to="/discounts/new">
          <Button size="small" block type="primary" htmlType="button">
            Create a discount code
          </Button>
        </Link>
      </div>
    </StyledNoUpcomingCallBox>
  );
}
